/* eslint-disable */

import React from "react";

function Header() {
  return (
    <header className="container user-avatar">
      <h1>calculate area of triangle</h1>
    </header>
  );
}
export default Header;
